<template>
  <div>
    <Header title="全校课表" type="0" route="/homeIndex" ></Header>
    <div class="classTable">
      <van-field
        v-model="xnxq.mc"
        label="学年学期"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="showPop('学年学期', 'xnxq')"
        readonly
      />
      <van-field
        v-model="cxwd.mc"
        label="查询维度"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="showPop('查询维度', 'cxwd')"
        readonly
      />
      <van-field
        v-model="sjms.mc"
        label="时间模式"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="showPop('时间模式', 'sjms')"
        readonly
      />
      <van-field
        v-if="cxwd.dm=='js'"
        v-model="kkdw.mc"
        label="开课单位"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="showPop('开课单位', 'kkdw')"
        readonly
      />
      <van-field
        v-if="cxwd.dm=='js'"
        v-model="skjs.mc"
        label="上课教师"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="showPop('上课教师', 'skjs')"
        readonly
      />

      <van-field
        v-if="cxwd.dm=='xs'"
        v-model="xs"
        label="学生"
        placeholder="请输入姓名/学号"
        input-align="right"
      />

      <van-field
        v-if="cxwd.dm=='kc'"
        v-model="kc"
        label="课程"
        placeholder="请输入课程/课程编号"
        input-align="right"
      />
      <van-field
        v-if="cxwd.dm=='bj'"
        v-model="bjssyx.mc"
        label="所属学院"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="showPop('所属学院', 'bjssyx')"
        readonly
      />
      <van-field
        v-if="cxwd.dm=='bj'"
        v-model="bjssnd.mc"
        label="年级"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="showPop('年级', 'bjssnd')"
        readonly
      />
      <van-field
        v-if="cxwd.dm=='bj'"
        v-model="bjsszy.mc"
        label="专业"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="showPop('专业', 'bjsszy')"
        readonly
      />
      <van-field
        v-if="cxwd.dm=='bj'"
        v-model="xx04.mc"
        label="班级名称"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="showPop('班级名称', 'xx04')"
        readonly
      />
<!--      <van-field-->
<!--        v-model="skbj"-->
<!--        rows="1"-->
<!--        type="textarea"-->
<!--        maxlength="200"-->
<!--        autosize-->
<!--        label="上课班级"-->
<!--        right-icon="arrow"-->
<!--        input-align="right"-->
<!--        placeholder="请点击选择"-->
<!--        @click="showMorePop()"-->
<!--        readonly-->
<!--      />-->
    </div>
    <div class="bottom-btn" @click="search">
      <button>查询</button>
    </div>
<!--    <van-popup-->
<!--      class="more"-->
<!--      v-model="show1"-->
<!--      closeable-->
<!--      @close="close"-->
<!--      position="bottom"-->
<!--      :style="{ height: '50%' }"-->
<!--    >-->
<!--      <p>{{ title }}</p>-->
<!--      <van-tabs v-model="active">-->
<!--        <van-tab-->
<!--          :title="item.value"-->
<!--          v-for="(item, index) of valueList1"-->
<!--          :key="index"-->
<!--        >-->
<!--          <ul>-->
<!--            <li-->
<!--              v-for="(value, num) of item.item"-->
<!--              :key="num"-->
<!--              @click="choose(item, value, index)"-->
<!--              :class="value.class"-->
<!--            >-->
<!--              {{ value.mc }}-->
<!--              <van-icon :name="value.success" />-->
<!--            </li>-->
<!--          </ul>-->
<!--        </van-tab>-->
<!--      </van-tabs>-->
<!--    </van-popup>-->
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index);
          }
        "
    /></van-popup>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";

export default {
  data() {
    return {
      active: 0,
      title: "",
      show: false,
      show1: false,
      sjms: {},
      xnxq: {},
      kkdw: {},
      bjssyx:{},
      bjssnd:{},
      bjsszy:{},
      allsszy:[],
      xx04:{},
      skjs: {},
      yxmc: "",
      sknj: "",
      sszy: "",
      ssbj: "",
      skbj: "",
      cxwd: {},
      xs:"",
      kc:"",
      columns: {
        sjms: [],
        xnxq: [],
        kkdw: [],
        skjs: [],
        bjssyx:{},
        bjssnd:{},
        bjsszy:{},
        xx04:{dm:''},
        cxwd:[
          {
            text: "学生班级",
            value: "bj",
          },
          {
            text: "教师维度",
            value: "js",
          },
          {
            text: "学生维度",
            value: "xs",
          },
          {
            text: "课程维度",
            value: "kc",
          }
        ]
      },
      valueList: {
        label: "",
        value: "",
        item: ""
      },
      valueList1: [
        {
          label: "学院名称",
          label1: "yxmc",
          value: "请选择",
          item: []
        },
        {
          label: "上课年级",
          label1: "sknj",
          value: "",
          item: []
        },
        {
          label: "所属专业",
          label1: "sszy",
          value: "",
          item: []
        },
        {
          label: "所属班级",
          label1: "ssbj",
          value: "",
          item: []
        }
      ]
    };
  },
  methods: {
    search() {
      if (this.cxwd.dm == "" || this.cxwd.dm==undefined) {
        this.$toast("请选择查询维度");
        return;
      }
      if (this.xnxq.dm == "" || this.xnxq.dm==undefined) {
        this.$toast("请选择学年学期");
        return;
      }
      if(this.cxwd.dm=='xs'&&this.xs==''){
        this.$toast("请先填写学生信息！");
        return;
      }
      if(this.cxwd.dm=='bj'&&(this.xx04.dm==undefined||this.xx04.dm=='')){
        this.$toast("请先选择班级！");
        return;
      }
      if(this.cxwd.dm=='js'&&(this.skjs.dm==undefined||this.skjs.dm=='')){
        this.$toast("请先选择老师！");
        return;
      }
      if(this.cxwd.dm=='kc'&&this.kc==''){
        this.$toast("请先填写课程信息！");
        return;
      }
      const params = {
        cxwd: this.cxwd,
        xnxqId: this.xnxq.dm,
        sjmsId: this.sjms.dm,
        kkdw:this.kkdw.dm,
        skjs:this.skjs.dm,
        xs:this.xs,
        kc:this.kc,
        xx04id:this.xx04.dm,
      };
      console.log(params)
      this.$router.push({
        name: "classTimeTableDetailqx",
        params: {
          route_params: encodeURI(JSON.stringify(params))
        }
      });
    },
    // 关闭联动框
    close() {
      this.active = 0;
    },
    // 联动框选择值
    choose(item, value, index) {
      item.value = value.mc;
      item.item.forEach(i => {
        i.class = "";
        i.success = "";
      });
      value.success = "success";
      value.class = "choose";
      this[item.label1] = value.dm;

      this.skbj =
        this.valueList1[0].value +
        "-" +
        this.valueList1[1].value +
        "-" +
        this.valueList1[2].value +
        "-" +
        this.valueList1[3].value;

      if (!!this.yxmc && !!this.sknj && !!this.sszy) {
        this.getClass();
      } else if (!!this.yxmc && !!this.sknj) {
        this.getNdzy();
      }
      if (index + 1 == this.valueList1.length) {
        this.show1 = false;
        console.log(this.valueList1);
        return;
      }

      this.valueList1[index + 1].value = "请选择";
      this.title = this.valueList1[index + 1].label;
      this.active = index + 1;
    },
    async getList() {
      const res = await Api.classcxtjList();
      // 获取学年学期
      this.getXnxq(res.xnxqdata);
      // 获取时间模式
      this.getSjms(res.sjmsdata);
      // 班级获取联动数据
      this.getMore(res.yxdata, res.njdata);
      // 获取开课单位
        this.getKKdw();
      // 获取单位,年级
      this.getDwAndNj();
    },
    async getKKdw() {

      const params = {
        semester: ''
      }
      const res = await Api.getTeachingKkdw(params)
      let kkdw = [];
      for (let i = 0; i < res.data.length; i++) {
        let value = {
          text: res.data[i].academyName,
          value: res.data[i].academyId,
        };
        kkdw.push(value);
      }
      this.columns.kkdw =kkdw;
      this.columns.kkdw.unshift({
        text: "空",
        value: ""
      });
    },
    async getDwAndNj(){
      const res = await Api.findXX0301andNd()
      let dw = [];
      if(res.code=='1'){
      for (let i = 0; i < res.data.xx0301list.length; i++) {
        let value = {
          text: res.data.xx0301list[i].dwmc,
          value: res.data.xx0301list[i].xx0301id,
        };
        dw.push(value);
      }
      this.columns.bjssyx =dw;
      let nd = [];
      for (let i = 0; i < res.data.ndList.length; i++) {
        let value = {
          text: res.data.ndList[i].rxnf,
          value: res.data.ndList[i].rxnf,
        };
        nd.push(value);
      }
      this.columns.bjssnd =nd;
      this.allsszy = res.data.zyList;
      }
    },

    async getSKjs(kkdwid) {

      const params = {
        kkdwid: kkdwid
      }
      const res = await Api.getTeachingSkjs(params)
      let skjs = [];
      for (let i = 0; i < res.data.length; i++) {
        let value = {
          text: res.data[i].academyName,
          value: res.data[i].academyId,
        };
        skjs.push(value);
      }
      this.columns.skjs =skjs;
      this.columns.skjs.unshift({
        text: "空",
        value: ""
      });

    },

    //获取班级
    async getClass() {
      const params = {
        academyId: this.yxmc,
        gradeId: this.sknj,
        majorId: this.sszy,
        type:'qxkbbj'
      };
      const res = await Api.getClassList(params);

      let skbj = [];
      res.data.forEach(item => {
        let value = {
          text: item.className,
          value: item.calssId
        };
        skbj.push(value);
      });
      this.columns.xx04 =skbj;
    },
    //获取年度专业
    async getNdzy() {
      const params = {
        academyId: this.yxmc,
        grade: this.sknj
      };
      const res = await Api.getAnnualMajorList(params);

      let ndzy = [];
      res.data.forEach(item => {
        let value = {
          mc: item.annumajorName,
          dm: item.annumajorId,
          success: "",
          class: ""
        };
        ndzy.push(value);
      });
      this.valueList1[2].item = ndzy;
      this.valueList1[2].item.unshift({
        mc: "全部",
        dm: "",
        success: "",
        class: ""
      });
    },
    // 获取学年学期
    getXnxq(data) {
      this.columns.xnxq = data.map(item => {
        return {
          text: item.semestername,
          value: item.semesterid
        };
      });
      this.columns.xnxq.unshift({
        text: "空",
        value: ""
      });
    },
    // 获取时间模式
    getSjms(data) {
      this.columns.sjms = data.map(item => {
        return {
          text: item.kbjcmsmc,
          value: item.kbjcmsid
        };
      });
      this.columns.sjms.unshift({
        text: "空",
        value: ""
      });
    },
    // 获取上课班级
    getMore(yxdata, njdata) {
      let yx = [];
      yxdata.forEach(item => {
        let value = {
          mc: item.academyname,
          dm: item.academyid,
          success: "",
          class: ""
        };
        yx.push(value);
      });
      this.valueList1[0].item = yx;

      let nj = [];
      njdata.forEach(item => {
        let value = {
          mc: item.gradename,
          dm: item.gradeid,
          success: "",
          class: ""
        };
        nj.push(value);
      });
      this.valueList1[1].item = nj;
    },
    // 弹出选择器
    showMorePop() {
      if (this.valueList1[0].item.length <= 0) {
        this.$toast("暂无班级数据");
        return;
      }
      this.title = this.valueList1[0].label;
      this.show1 = true;
    },
    getZyObj(yxid,nj){
       let zyobj = [];
        this.allsszy.forEach(item=>{
          if(item.xx0301id==yxid&&item.ksnd==nj){
              let valueObj = {
                text: item.zymc,
                value: item.jx01ndid,
              };
              zyobj.push(valueObj);
          }
        }) 
        return zyobj; 
    },
    showPop(label, value) {
      if(value=='bjsszy'){
        if(this.yxid==''){
          this.$toast("请先选择所属学院！");
          return;
        }
        if(this.sknj==''){
          this.$toast("请先选择年级！");
          return;
        }
        this.show = true;
        this.valueList.label = label;
        this.valueList.value = value;
        this.valueList.item = this.getZyObj(this.yxmc,this.sknj);
      }else if(value=='xx04'){
        if(this.yxid==''){
          this.$toast("请先选择所属学院！");
          return;
        }
        if(this.sknj==''){
          this.$toast("请先选择年级！");
          return;
        }
        if(this.sszy==''){
          this.$toast("请先选择专业！");
          return;
        }
        this.show = true;
        this.valueList.label = label;
        this.valueList.value = value;
        this.valueList.item = this.columns[value];
      }else{
        this.show = true;
        this.valueList.label = label;
        this.valueList.value = value;
        this.valueList.item = this.columns[value];
      }

    },
    onConfirm(value) {
      let value1 = this.valueList.value;
      if(value1=='cxwd'){
        // 获取开课单位
        if(this.cxwd.dm=="js"){
          this.getKKdw();
        }
      }
      // 获取开课单位下面的上课教师
      if(value1=='kkdw'){
        this.getSKjs(value.value);
      }
      if(value1=='bjssyx'){
        this.yxmc = value.value;
        this.bjsszy = {};
        this.sszy = '';
        this.xx04 = {}
        this.xx04id = ''
        //this.getClass(value.value);
      }
      if(value1=='bjssnd'){
        this.sknj = value.value;
        this.bjsszy = {};
        this.sszy = '';
        this.xx04 = {}
        this.xx04id = ''
        //this.getClass(value.value);
      }
      if(value1 =='bjsszy'){
        this.sszy = value.value;
        this.getClass(value.value);
      }
      this.show = false;
      this[value1].mc = value.text;
      this[value1].dm = value.value;
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less">
.classTable {
  padding: 5% 5% 0;

  .van-cell {
    padding: 10px 0;
    border-bottom: 1px solid #f4f4f4;
  }
  .van-cell::after {
    display: none;
  }
  .van-field__label {
    width: 7.2em;
  }
  .van-cell.van-field .van-cell__title.van-field__label > span {
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
  }
  .van-field__control::-webkit-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control::-moz-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    font-weight: normal;
    letter-spacing: 0;
    text-align: right;
  }
  .van-field__control::-ms-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
    text-align: right;
    font-weight: bolder;
  }
  .van-icon-arrow {
    color: #dfe0e6;
    font-weight: bolder;
    font-size: 14px;
  }
}
.bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding-bottom: 10px;
  padding: 0 5%;
  background: #fff;
  box-sizing: border-box;

  button {
    width: 100%;
    height: 44px;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
  }
}
.more.van-popup.van-popup--bottom {
  border-radius: 0 !important ;
}
.more {
  padding: 5% 0 5% 0;
  box-sizing: border-box;
  overflow: hidden;
  .van-tabs__content--animated {
    height: 75vh;
    overflow: auto;
  }
  .van-tabs--line .van-tabs__wrap {
    border-bottom: 1px solid #f4f4f4;
    .van-tab--active {
      .van-tab__text--ellipsis {
        color: #212f6e !important;
      }
    }
    .van-tab__text--ellipsis {
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #8f95b5;
      text-align: center;
      letter-spacing: 0;
    }
    .van-tabs__line {
      background-color: #7469f8 !important;
      width: 25px;
      height: 3px;
      border-radius: 1.5px;
    }
  }
  & > p {
    width: 64px;
    font-weight: bolder;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    padding-left: 7%;
  }
  ul {
    overflow: auto;
    height: 36vh;
    .choose {
      background-color: #f8f8f8;
    }
    li {
      height: 40px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #212f6e;
      font-weight: bold;
      display: flex;
      align-items: center;
      padding-right: 5%;
      padding-left: 7%;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/classTable/indexqx.vue